
  import { css } from 'lit';
  export const styles = css`:host([selected]) [part="toggle focused"]{color:var(--item-selected-hover-text-color)}:host([selected]) [part="toggle focused"] ::slotted(igc-icon){color:var(--item-selected-hover-icon-color)}`;
  